import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0db9368b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Receiver User", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Receiver Account", -1))
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Amount", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Ticket", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Symbol", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Volume", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Status", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "" }, "Date Time", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "" }

import { ref, onMounted, inject } from "vue";
import RebateService from "../services/RebateService";
import BalanceShow from "@/components/BalanceShow.vue";
import TimeShow from "@/components/TimeShow.vue";
import i18n from "@/core/plugins/i18n";
import TableFooter from "@/components/TableFooter.vue";
import RebateDetail from "../components/RebateDetail.vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import {
  TenantRebateCriteria,
  TenantRebateViewModel,
} from "@/core/models/Rebate";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import { TimeZoneService } from "@/core/plugins/TimerService";


export default /*#__PURE__*/_defineComponent({
  __name: 'IbRecord',
  setup(__props) {

const { t } = i18n.global;
const RebateDetailRef = ref<any>(null);
const isLoading = inject<any>("isLoading");
const rebateList = ref(Array<TenantRebateViewModel>());
const searchType = ref(0);
const searchValue = ref("");

const addDateRange = () => {
  const today = new Date();
  const from = new Date(today);
  const to = new Date(today);

  // Set the from date to one month prior to today
  from.setMonth(today.getMonth() - 1);

  // Format dates to 'YYYY-MM-DD' string format
  criteria.value.from = TimeZoneService.adjustDateToKeepsYearMonthDate(from);
  criteria.value.to = TimeZoneService.adjustDateToKeepsYearMonthDate(to);
};

const criteria = ref<TenantRebateCriteria>({
  page: 1,
  size: 10,
  sortField: "id",
} as TenantRebateCriteria);

addDateRange();

const search = async () => {
  if (searchValue.value === "") {
    return;
  }
  await resetCriteria();
  switch (searchType.value) {
    case 0:
      criteria.value.accountNumber = searchValue.value;
      break;
    case 1:
      criteria.value.accountUid = searchValue.value;
      break;
    case 2:
      criteria.value.email = searchValue.value;
      break;
    case 3:
      criteria.value.ticketNumber = searchValue.value;
      break;
  }
  await fetchData(1);
};

const reset = async () => {
  searchValue.value = "";

  await resetCriteria();
  await fetchData(1);
};

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  criteria.value.sortField = "id";
  try {
    isLoading.value = true;
    const res = await RebateService.queryRebates(criteria.value);
    rebateList.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const resetCriteria = () => {
  criteria.value = {
    page: 1,
    size: 10,
    sortField: "id",
  } as TenantRebateCriteria;
  addDateRange();
};

const pageChange = (_page: number) => {
  fetchData(_page);
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_select, {
          disabled: _unref(isLoading),
          modelValue: searchType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
          class: "w-175px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              value: 0,
              label: "Account Number"
            }),
            _createVNode(_component_el_option, {
              value: 1,
              label: "Account Uid"
            }),
            _createVNode(_component_el_option, {
              value: 2,
              label: "Email"
            }),
            _createVNode(_component_el_option, {
              value: 3,
              label: "Ticket Number"
            })
          ]),
          _: 1
        }, 8, ["disabled", "modelValue"]),
        _createVNode(_component_el_input, {
          disabled: _unref(isLoading),
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
          class: "ms-3 w-250px",
          placeholder: "Search",
          clearable: ""
        }, null, 8, ["disabled", "modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "ms-3",
          onClick: search,
          loading: _unref(isLoading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: reset,
          disabled: _unref(isLoading)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.currency")), 1),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ])
        ]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
              _createVNode(LoadingRing)
            ]))
          : (!_unref(isLoading) && rebateList.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                _createVNode(NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebateList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_19, [
                      (item.targetAccount.user)
                        ? (_openBlock(), _createBlock(_component_UserInfo, {
                            key: 0,
                            user: item.targetAccount.user,
                            class: "me-2"
                          }, null, 8, ["user"]))
                        : _createCommentVNode("", true)
                    ]),
                    (item.targetAccount.role == 100)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_20, " [" + _toDisplayString(item.targetAccount.code) + "]" + _toDisplayString(item.targetAccount.uid), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_21, " [" + _toDisplayString(item.targetAccount.group) + "]" + _toDisplayString(item.targetAccount.uid), 1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(t)(`type.currency.${item.currencyId}`)), 1),
                    _createElementVNode("td", _hoisted_22, [
                      _createVNode(BalanceShow, {
                        "currency-id": item.currencyId,
                        balance: item.amount
                      }, null, 8, ["currency-id", "balance"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.trade.ticket), 1),
                    _createElementVNode("td", null, _toDisplayString(item.trade.symbol), 1),
                    _createElementVNode("td", null, _toDisplayString(item.trade.volume), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(t)(`type.transactionState.${item.status}`)), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        type: "exactTime",
                        "date-iso-string": item.postedOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]))
                }), 128))
              ]))
      ]),
      _createVNode(TableFooter, {
        onPageChange: pageChange,
        criteria: criteria.value
      }, null, 8, ["criteria"])
    ]),
    _createVNode(RebateDetail, {
      ref_key: "RebateDetailRef",
      ref: RebateDetailRef
    }, null, 512)
  ]))
}
}

})